const langInvestFundPerformancesVentureCapitalLang = {
	title_capital: {
		tag: 'invest.fund_performances_venture_capital.title_capital',
		fr: 'CAPITAL',
		en: 'CAPITAL',
	},
	text_your_position: {
		tag: 'invest.fund_performances_venture_capital.text_your_position',
		fr: 'Votre position',
		en: 'Your position',
	},
	text_fund_total: {
		tag: 'invest.fund_performances_venture_capital.text_fund_total',
		fr: 'Total du fonds',
		en: 'Funds total',
	},
	committed_capital: {
		tag: 'invest.fund_performances_venture_capital.committed_capital',
		fr: 'Capital engagé',
		en: 'Committed capital',
	},
	called_capital: {
		tag: 'invest.fund_performances_venture_capital.called_capital',
		fr: 'Capital appelé',
		en: 'Called capital',
	},
	callable_capital: {
		tag: 'invest.fund_performances_venture_capital.callable_capital',
		fr: 'Reste à appeler',
		en: 'Uncalled capital',
	},

	distributions: {
		tag: 'invest.fund_performances_venture_capital.distributions',
		fr: 'Distributions',
		en: 'Distributed',
	},
	distributions_recallable: {
		tag: 'invest.fund_performances_venture_capital.distributions_recallable',
		fr: 'Distributions rappelables',
		en: 'Recallable distributions',
	},
	fees: {
		tag: 'invest.fund_performances_venture_capital.fees',
		fr: 'Fees',
		en: 'Fees',
	},
	title_fund: {
		tag: 'invest.fund_performances_venture_capital.title_fund',
		fr: 'FONDS',
		en: 'FUND',
	},
	nav: {
		tag: 'invest.fund_performances_venture_capital.nav',
		fr: 'NAV',
		en: 'NAV',
	},
	irr: {
		tag: 'invest.fund_performances_venture_capital.irr',
		fr: 'TRI net',
		en: 'Net IRR',
	},
	irr_gross: {
		tag: 'invest.fund_performances_venture_capital.irr_gross',
		fr: 'Tri brut',
		en: 'Gross IRR',
	},
	irr_gross_tooltip: {
		tag: 'invest.fund_performances_venture_capital.irr_gross_tooltip',
		fr: 'Tri brut du fonds',
		en: 'Gross IRR of the fund',
	},

	tvpi: {
		tag: 'invest.fund_performances_venture_capital.tvpi',
		fr: 'TVPI',
		en: 'TVPI',
	},

	dpi: {
		tag: 'invest.fund_performances_venture_capital.dpi',
		fr: 'DPI',
		en: 'DPI',
	},
	rvpi: {
		tag: 'invest.fund_performances_venture_capital.rvpi',
		fr: 'RVPI',
		en: 'RVPI',
	},
	title_portfolio: {
		tag: 'invest.fund_performances_venture_capital.title_portfolio',
		fr: 'PORTEFEUILLE',
		en: 'FUND PORTFOLIO',
	},
	capital_invested: {
		tag: 'invest.fund_performances_venture_capital.capital_invested',
		fr: 'Capital investi',
		en: 'Capital invested',
	},
	realized_gains: {
		tag: 'invest.fund_performances_venture_capital.realized_gains',
		fr: 'Gains capital réalisés',
		en: 'Realized portfolio gains',
	},
	unrealized_gains: {
		tag: 'invest.fund_performances_venture_capital.unrealized_gains',
		fr: 'Gains capital non réalisés',
		en: 'Un-realized portfolio gains',
	},
	percent_of_capital_called_invested: {
		tag: 'invest.fund_performances_venture_capital.percent_of_capital_called_invested',
		fr: 'Investi',
		en: 'Invested',
	},
	percent_of_capital_called_invested_sub: {
		tag: 'invest.fund_performances_venture_capital.percent_of_capital_called_invested_sub',
		fr: 'en % du capital appelé',
		en: '% of capital called',
	},
	total_value: {
		tag: 'invest.fund_performances_venture_capital.total_value',
		fr: 'Valeur totale des actifs',
		en: 'Assets total value',
	},
	total_value_sub: {
		tag: 'invest.fund_performances_venture_capital.total_value_sub',
		fr: '(réalisé + non réalisé)',
		en: '(exit + active)',
	},
	moic: {
		tag: 'invest.fund_performances_venture_capital.moic',
		fr: 'MOIC',
		en: 'MOIC',
	},
};

export default langInvestFundPerformancesVentureCapitalLang;
